

















































































import { isEnableCombinedDiscountCode } from "@/utils/experiment";
import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class discountDialog extends Vue {
  @Prop()
  discountDialogShow!: boolean;

  @Prop()
  handleClose!: Function;

  @Prop()
  close!: Function;

  @Prop()
  discountData?: any;

  discount = this.initDiscountData(this.discountData);

  initDiscountData(data: any) {
    const defaultData = {
      valueType: 2,
      minBuyRequireType: 0,
      ...(this.enableCombinedDiscountCode ? {
        combinesWithProduct: false,
        combinesWithOrder: false,
        combinesWithShipping: false
      } : {})
    };
    const discountData = JSON.parse(JSON.stringify(data || defaultData));
    // 确保三个属性存在
    if (this.enableCombinedDiscountCode) {
      if (discountData.combinesWithProduct === undefined) {
        discountData.combinesWithProduct = false;
      }
      if (discountData.combinesWithOrder === undefined) {
        discountData.combinesWithOrder = false;
      }
      if (discountData.combinesWithShipping === undefined) {
        discountData.combinesWithShipping = false;
      }
    }
    return discountData;
  }

  get enableCombinedDiscountCode() {
    return isEnableCombinedDiscountCode()
  }

  @Watch('discountDialogShow')
  changeData() {
    if (this.discountDialogShow) {
      this.discount = this.initDiscountData(this.discountData);
    }
  }

  beforeClose() {
    this.$refs?.form?.clearValidate && this.$refs.form.clearValidate();
    this.$refs?.form?.resetFields && this.$refs.form.resetFields();
    this.close && this.close();
  }

  clearKongge() {
    this.discount.codePrefix = `${this.discount.codePrefix??''}`.replaceAll(' ', '').substring(0, 10);
  }
  clear30() {
    this.discount.reserveCode = `${this.discount.reserveCode??''}`.substring(0, 30);
  }

  validAndClose() {
    this.$refs.form?.validate((valid:boolean) => {
      if (valid) {
        this.handleClose && this.handleClose(this.discount);
      } else {
        // console.log('error submit!!!');
        return false;
      }
    });
    window?.gtagClick('form_edit_setDiscountCode','弹窗_编辑订阅工具_设置动态折扣码')
  }

  changeDiscountAmount() {
    // 最多9位数，加小数点后2位数
    const strArr = `${this.discount.amount??''}`.split('.');
    let start = strArr[0];
    let end = strArr.length > 1 ? strArr[1] : '';
    this.discount.amount = `${start}`.substring(0, 9) + (strArr.length > 1?('.' + `${end}`.substring(0, 2)):'');
  }

  changeMinBuyAmount() {
    const strArr = `${this.discount.minBuyAmount??''}`.split('.');
    let start = strArr[0];
    let end = strArr.length > 1 ? strArr[1] : '';
    this.discount.minBuyAmount = `${start}`.substring(0, 9) + (strArr.length > 1?('.' + `${end}`.substring(0, 2)):'');
  }

  changeMinBuyCount() {
    this.discount.minBuyCount = `${this.discount.minBuyCount??''}`.substring(0, 9)
  }

  isTwoDecimalPlaces(number:any) {
    return /^(\-)?\d+(\.\d{1,2})?$/.test(`${Number(number)}`);
  }

  // 校验
  validateAmount(rule:any, value:any, callback:any) {
    if (value === undefined || value === null || (typeof value === 'string' && value.length === 0)) {
      return callback(new Error('值类型不可为空'));
    }
    setTimeout(() => {
      if (Number.isNaN(value)) {
        callback(new Error('仅支持输入数字及小数点后两位'));
      } else {
        if (Number(value) < 0) {
          callback(new Error('仅支持输入数字及小数点后两位'));
        } else {
          if (this.isTwoDecimalPlaces(value)) {
            callback();
          } else {
            callback(new Error('仅支持输入数字及小数点后两位'));
          }
        }
      }
    }, 10);
  }
  validatePercent(rule:any, value:any, callback:any) {
    if (value === undefined || value === null || (typeof value === 'string' && value.length === 0)) {
      return callback(new Error('值类型不可为空'));
    }
    setTimeout(() => {
      if (Number.isNaN(value)) {
        callback(new Error('仅支持输入0-100整数数字'));
      } else {
        if (Number(value) < 0 || Number(value) > 100) {
          callback(new Error('仅支持输入0-100整数数字'));
        } else {
          if (Number.isInteger(Number(value))) {
            callback();
          } else {
            callback(new Error('仅支持输入0-100整数数字'));
          }
        }
      }
    }, 10);
  }
  validateMinBuyAmount(rule:any, value:any, callback:any) {
    if (value === undefined || value === null || (typeof value === 'string' && value.length === 0)) {
      return callback(new Error('最低购买要求值不可为空'));
    }
    setTimeout(() => {
      if (Number.isNaN(value)) {
        callback(new Error('仅支持输入数字及小数点后两位'));
      } else {
        if (Number(value) < 0) {
          callback(new Error('仅支持输入数字及小数点后两位'));
        } else {
          if (this.isTwoDecimalPlaces(value)) {
            callback();
          } else {
            callback(new Error('仅支持输入数字及小数点后两位'));
          }
        }
      }
    }, 10);
  }
  validateMinBuyCount(rule:any, value:any, callback:any) {
    if (value === undefined || value === null || (typeof value === 'string' && value.length === 0)) {
      return callback(new Error('最低购买要求值不可为空'));
    }
    setTimeout(() => {
      if (Number.isNaN(value)) {
        callback(new Error('仅支持输入>0整数数字'));
      } else {
        if (Number(value) < 0) {
          callback(new Error('仅支持输入>0整数数字'));
        } else {
          if (Number.isInteger(Number(value))) {
            callback();
          } else {
            callback(new Error('仅支持输入>0整数数字'));
          }
        }
      }
    }, 10);
  }
}
